<template>
  <v-dialog v-model="isShowAreaModal" max-width="1000" persistent>
    <v-card class="wrapper">
      <v-card-title>
        <span class="headline">対象エリア</span>
      </v-card-title>
      <v-card-text>
        <v-container class="container">
          <AppAreaSelector :menuSetting="tmpPoiSearchForm" />
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeModal">
          キャンセル
        </v-btn>
        <v-btn @click="onClickSave" color="primary">
          登録
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'TargetAreaFormModal',
  props: {
    isShowAreaModal: {
      type: Boolean,
      default: false,
    },
    poiSearchForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tmpPoiSearchForm: cloneDeep(this.poiSearchForm),
    }
  },
  watch: {
    isShowAreaModal() {
      this.tmpPoiSearchForm = cloneDeep(this.poiSearchForm)
    },
  },
  methods: {
    onClickSave() {
      this.$emit('onClickSave', this.tmpPoiSearchForm)
      this.closeModal()
    },
    closeModal() {
      this.$emit('closeModal')
    },
  },
}
</script>

<style scoped>
.wrapper {
  height: 550px;
}
.container {
  padding-top: 0;
}
</style>
